import React from 'react';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { Task } from '@ragu-components/ord-types';

const TaskList = React.lazy(async () => import('./TaskList'));

export const taskResource: OrdResourceProps = {
  key: 'tasks',
  name: 'tasks',
  list: <TaskList />,
  options: {},
  recordRepresentation: (task: Task): string => task.id,
};
